import { Card } from "@/shared/components/ui/card";

export function S3KeyList({ keys }: { keys: string[] }) {
    if (keys.length === 0) return null;

    return (
        <div className="space-y-2">
            <div className="text-sm">
                총 <span className="font-semibold">{keys.length}</span>개 파일
            </div>
            <Card className="p-4">
                <ul className="list-disc space-y-1 pl-5 text-sm">
                    {keys.map((k) => (
                        <li key={k} className="break-words">
                            {k}
                        </li>
                    ))}
                </ul>
            </Card>
        </div>
    );
}